import { css } from 'styled-components'

import { WHITE, PB90T } from '@h2/components/colors'

const fetchingStyles = css`
  background-color: ${({ isFetching }) => (isFetching ? '' : WHITE)};
  border: ${({ isFetching }) => (isFetching ? '' : `solid 1px ${PB90T}`)};
`

export { fetchingStyles }
